import * as cart from "./cart";
import * as sales from "./sales";

export default function initClientInfo() {

    function hasChanged(original, current) {
        for (let i = 0; i < original.length; i++) {
            if (original[i] !== current[i].value) {
                return true
            }
        }

        return false;
    }

    const profileInfoBlock = document.querySelector('.profile-info-block');

    if (profileInfoBlock) {
        const saveButton = profileInfoBlock.querySelector('.submit');
        const form = profileInfoBlock.querySelector('.axios-profile-info');
        const observeInputs = profileInfoBlock.querySelectorAll('.profile-info-observe-input');

        let original = [];

        for (const el of observeInputs) {
            original.push(el.value);

            el.addEventListener('input', () => {
                if (hasChanged(original, observeInputs)) {
                    saveButton.classList.remove('d-none');

                    for (const s of  form.querySelectorAll('.general-success')) {
                        s.remove();
                    }
                } else {
                    saveButton.classList.add('d-none');
                }
            });
        }

        form.addEventListener('submit', async (e) => {
            e.preventDefault();

            if (form.classList.contains('loading')) {
                return;
            }

            form.classList.add('loading');

            const url = form.action + '?rest_language=' + document.documentElement.lang.split('-')[0];
            const method = form.method.toLowerCase();
            const data = new FormData(form);

            const generalErrors = form.querySelectorAll('.general-error');
            for (const el of generalErrors) {
                if (!el.classList.contains('axios-no-remove')) {
                    el.remove();
                }
            }

            const generalSuccess = form.querySelectorAll('.general-success');
            for (const el of generalSuccess) {
                if (!el.classList.contains('axios-no-remove')) {
                    el.remove();
                }
            }

            const fields = form.querySelectorAll('.input');
            for (const el of fields) {
                el.classList.remove('invalid');
            }

            const messageFields = form.querySelectorAll('.input-error');
            for (const el of messageFields) {
                el.remove();
            }

            let response;

            try {
                if (method === 'get') {
                    response = await axios.get(url);
                } else if (method === 'post') {
                    response = await axios.post(url, data, {headers: {'Content-Type': 'multipart/form-data'}});
                }

                response = response.data;
            } catch (error) {
                response = error.response.data;
            }

            if (response && response.errors && Object.keys(response.errors).length) {
                for (let i = 0, keys = Object.keys(response.errors), ii = keys.length; i < ii; i++) {
                    const input = form.querySelector("[name='" + keys[i] + "']");

                    if (input) {
                        input.classList.add('invalid');

                        const messageNode = document.createElement('span');
                        messageNode.classList.add('input-error');
                        messageNode.innerHTML = response.errors[keys[i]];
                        input.parentNode.insertBefore(messageNode, input.nextSibling);
                    }
                }

                form.classList.remove('loading');

            } else if (response && response.general_error) {
                const messageNode = document.createElement('span');
                messageNode.classList.add('general-error');
                messageNode.innerHTML = response.general_error;
                form.appendChild(messageNode);
                form.classList.remove('loading');

            } else if (response && response.general_success) {
                const messageNode = document.createElement('span');
                messageNode.classList.add('general-success');
                messageNode.innerHTML = response.general_success;
                form.appendChild(messageNode);
                form.classList.remove('loading');

                if (response.hide) {
                    messageNode.classList.add('p-0');

                    for (const el of form.querySelectorAll('.axios-hide')) {
                        el.classList.add('d-none');
                    }
                }

                if (response.clear) {
                    for (const el of form.querySelectorAll('.axios-clear')) {
                        el.value = '';
                    }
                }

                original = [];
                for (const el of observeInputs) {
                    original.push(el.value);
                }

                saveButton.classList.add('d-none');

            } else {
                const messageNode = document.createElement('span');
                messageNode.classList.add('general-error');
                let globalErrorMessage = document.getElementById('global_axios_validator_error');

                if (!globalErrorMessage) {
                    globalErrorMessage = 'An error occurred';
                } else {
                    globalErrorMessage = globalErrorMessage.innerHTML;
                }

                messageNode.innerHTML = globalErrorMessage;
                form.appendChild(messageNode);
                form.classList.remove('loading');
            }
        });
    }
}
